import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_ROLE = "identity-service/access-management/roles";

const RESOURCES = {
	PAGINATED_ROLES: (page, searchText, clientId, orderBy) =>
		`${BASE_ROLE}/paginated?page=${page}&limit=8` +
		`&searchBy=${searchText}&orderBy=${orderBy.collumnTitle}&orderDirection=${orderBy.orderDirection}`,
	LIST_ROLES: () => `${BASE_ROLE}`,
	GET_ROLE: (id) => `${BASE_ROLE}/${id}`,
	CREATE_ROLE: () => `${BASE_ROLE}`,
	UPDATE_ROLE: (id) => `${BASE_ROLE}/${id}`,
	DELETE_ROLE: (id) => `${BASE_ROLE}/${id}`,
};

class RoleService {
	static async getPaginated(page, searchText, clientId, orderBy) {
		try {
			return await axios.get(
				RESOURCES.PAGINATED_ROLES(page, searchText, clientId, orderBy),
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao listar funções paginados",
			});
			return error.response;
		}
	}

	static async listRoles() {
		try {
			return await axios.get(RESOURCES.LIST_ROLES());
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao listar perfil",
			});
			return error.response;
		}
	}

	static async getRole(id) {
		try {
			return await axios.get(RESOURCES.GET_ROLE(id));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao buscar perfil",
			});
			return error.response;
		}
	}

	static async createRole(payload) {
		try {
			const response = await axios.post(RESOURCES.CREATE_ROLE(), payload);
			ResponseAlerts({
				response,
				successMessage: "Perfil criada com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao criar perfil",
			});
			return error.response;
		}
	}

	static async updateRole(id, payload) {
		try {
			const response = await axios.put(RESOURCES.UPDATE_ROLE(id), payload);
			ResponseAlerts({
				response,
				successMessage: "Perfil atualizada com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao atualizar perfil",
			});
			return error.response;
		}
	}

	static async deleteRole(id) {
		try {
			const response = await axios.delete(RESOURCES.DELETE_ROLE(id));
			ResponseAlerts({
				response,
				successMessage: "Perfil removida com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao remover perfil",
			});
			return error.response;
		}
	}
}

export default RoleService;
